import React from 'react';
import { CheckoutButton } from '../CheckoutButton';
import { VOLUMES } from '../../data/welding';
import { PRICE } from '../../data/checkout';
export function FinalCta() {
  return <section aria-labelledby="final-title" className="blueprint-grid bg-surface py-14 sm:py-20" data-id="element-177" data-mp="1np9eeph4wpaa">
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-5 text-center sm:px-8" data-id="element-178" data-mp="1snt2avfagb5a">
        <ul className="grid w-full max-w-md grid-cols-6 gap-1.5" aria-hidden data-id="element-179" data-mp="1eojmhwuzvj1u">
          {VOLUMES.map(volume => <li key={volume.number} data-id="element-180" data-mp="1iq560121avl0">
              <img src={volume.src} alt="" width={volume.width} height={volume.height} loading="lazy" decoding="async" className="aspect-square w-full rounded-[3px] object-contain ring-1 ring-white/10" data-id="element-181" data-mp="1ir7ww8zcwy0x" />
            </li>)}
        </ul>
        <h2 id="final-title" className="mt-8 font-heading text-[2.05rem] font-bold uppercase leading-[0.98] text-white min-[390px]:text-[2.25rem] sm:text-[2.8rem] lg:text-[3.2rem]" data-id="element-182" data-mp="3426lhmz3k2ez">
          YOUR NEXT WORKSHOP BUILD STARTS WITH A PLAN.
        </h2>
        <p className="mt-4 text-[1.02rem] leading-relaxed text-steel-pale sm:text-[1.1rem]" data-id="element-183" data-mp="b1yf87o5hn85">
          Get all 30 projects, six volumes, and five bonus resources.
        </p>
        <CheckoutButton id="final-cta" label={`GET THE COLLECTION — ${PRICE.label}`} size="lg" className="mt-7 w-full sm:w-auto" data-id="element-184" data-mp="727jdpjrogwr" />
      </div>
    </section>;
}